import { apiRoot } from "../../../old/beheer/store/api/apiRoot";

const priceLineEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["ProductPriceLine"],
});

export type ProductPriceLine = {
  id: number;
  product_id: number;
  price_in_cents: number;
  sales_area_price_line_id: number;
};

export const priceLineApi = priceLineEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    updateOrCreateProductPriceLine: builder.mutation<
      any,
      {
        sales_area_id: number;
        sales_area_price_line_id: number;
        product_id: number;
        price_in_cents: number | null;
      }
    >({
      invalidatesTags: ["ProductPriceLine"],
      query: (body) => {
        return {
          url: `/product-price-lines/update-or-create`,
          method: "POST",
          body,
        };
      },
    }),
  }),
});

export const { useUpdateOrCreateProductPriceLineMutation } = priceLineApi;
